import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

function SuccessModal({ onClose, message ,heading}) {
    return (
        <Transition appear show={true} as={Fragment}>
            <Dialog as="div" className="relative z-[999999]" onClose={()=>onClose()}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-white p-4 text-left align-middle shadow-xl transition-all">
                                {/* Success Message */}
                                <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                                      {heading}
                                </Dialog.Title>
                                <div className="mt-2">
                                    <p className="text-sm text-gray-500">{message}</p>
                                </div>

                                {/* OK Button */}
                                <div className="flex justify-end mt-4">
                                    <button
                                        onClick={() => onClose()}
                                        className="bg-[#5550d2] text-white px-5 py-2 rounded"
                                    >
                                        OK
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}

export default SuccessModal;
